import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "VehicleListPage" */
	'pages/vehicle/Vehicle/VehicleListPage'));

export default [{ component, exact: true, path: '/vehicles' }];